module.exports = __webpack_public_path__ + "static/media/foot-length.41e84cf8.svg";